import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import {NOTIFICATION, NOTIFICATION_FILTER, NOTIFICATION_MAIN_FILTER} from './notifications.type';
import notificationsServices from './notificationsServices';

const initialState = {
  isLoading: false,
  is_read: false,
  notifications: {
    page_size: 10,
    page_number: 1,
    totalDataCount: 0,
    pageData: [] as NOTIFICATION[],
  },
};

export const notifications = createAsyncThunk(
  'notifications',
  async (payload: {body?: NOTIFICATION_MAIN_FILTER; filters?: NOTIFICATION_FILTER}, thunkAPI) => {
    try {
      const data: AxiosResponse = await notificationsServices.notifications(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setIsRead(state, action: PayloadAction<boolean>) {
      state.is_read = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(notifications.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(notifications.fulfilled, (state, action) => {
      state.isLoading = false;
      state.notifications = action.payload.data;
      state.is_read = action.payload.data.pageData.some((x: NOTIFICATION) => {
        return x.is_read === false;
      });
    });
    builder.addCase(notifications.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});

export const {setIsRead} = notificationsSlice.actions;

export default notificationsSlice.reducer;
